import { render } from "./ScanAlignmentEditor.vue?vue&type=template&id=0c5cb093&scoped=true"
import script from "./ScanAlignmentEditor.vue?vue&type=script&lang=js"
export * from "./ScanAlignmentEditor.vue?vue&type=script&lang=js"

import "./ScanAlignmentEditor.vue?vue&type=style&index=0&id=0c5cb093&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5cb093"]])

export default __exports__